import { useNavigate } from "react-router-dom";
import { ArrowLeft, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import AppShell from "@/components/layout/AppShell";

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <AppShell topbarProps={{ showSearch: false, showAdd: false }}>
      <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-4 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-muted">
          <Compass className="h-8 w-8 text-muted-foreground" />
        </div>
        <h1 className="font-heading mt-5 text-3xl font-bold tracking-tight">
          Page introuvable
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <div className="mt-6 flex gap-2">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
            data-testid="not-found-back"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour
          </Button>
          <Button
            onClick={() => navigate("/")}
            data-testid="not-found-home"
            className="bg-accent-navy text-white hover:bg-accent-navy/90 dark:bg-primary dark:text-primary-foreground"
          >
            Tableau de bord
          </Button>
        </div>
      </div>
    </AppShell>
  );
}
